export const simulationModes = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTI'
}
